import styled              from 'styled-components';
 
import { LoadingVariants } from 'src/components/common/loading';

import { cssFlexColumn, 
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors,        
         cssFlexRowCC    } from 'src/providers/theme/shared';



type AttachmentPhotoLookAndFeel = {
  paddings: number[];
  height: number;
  gap: number;
  actionsSize: number;
  actionsTop: number;
  actionsRight: number;
  actionsColor: string;
  actionsBgColor: string;

  photoAreaHeight: number;
  photoAreaColor: string;

  labelTypo: Typo;
  labelColor: string;

  containerBorderColor: string;
  containerBackgroundColor: string;

  loadingVariant: LoadingVariants;
}

const attachmentphoto_light: AttachmentPhotoLookAndFeel = {
  paddings: [4, 4, 12, 4],
  height: 131,
  gap: 10,
  actionsSize: 36,
  actionsTop: 4,
  actionsRight: 4,
  actionsColor: themeColors.PrimaryWhite,
  actionsBgColor: 'rgba(0, 0, 0, 0.5)',

  photoAreaHeight: 76,
  photoAreaColor: themeColors.SecondaryGray1,

  labelTypo: themeTypos.GRTSKREG_W400_S10_LH12,
  labelColor: themeColors.PrimaryBlack,

  containerBorderColor: themeColors.SecondaryGray3,
  containerBackgroundColor: themeColors.PrimaryWhite,

  loadingVariant: 'lightblue24',
}

export type AttachmentPhotoVariants = 'light';

export const attachmentphoto_variants: Map<AttachmentPhotoVariants, AttachmentPhotoLookAndFeel> = 
  new Map<AttachmentPhotoVariants, AttachmentPhotoLookAndFeel>([
    ['light', attachmentphoto_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: AttachmentPhotoLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap}px;
  height: ${(args) => args.lookAndFeel.height}px;
  position: relative;

  padding: ${(args) => args.lookAndFeel.paddings[0]}px
           ${(args) => args.lookAndFeel.paddings[1]}px
           ${(args) => args.lookAndFeel.paddings[2]}px
           ${(args) => args.lookAndFeel.paddings[3]}px;

  border: 1px solid ${(args) => args.lookAndFeel.containerBorderColor};

  background-color: ${(args) => args.lookAndFeel.containerBackgroundColor};

  & img {
    height: ${(args) => args.lookAndFeel.photoAreaHeight}px;
  }
`

export const PhotoArea = styled.div<{
  lookAndFeel: AttachmentPhotoLookAndFeel
}>`
  ${cssFlexRowCC};
  height: ${(args) => args.lookAndFeel.photoAreaHeight}px;

  background-color: ${(args) => args.lookAndFeel.photoAreaColor};

  & img {
    width: 100%;
    object-fit: cover;
  }
`

export const Label = styled.div<{
  lookAndFeel: AttachmentPhotoLookAndFeel;
}>`
  ${cssFlexRowCC};
  flex-grow: 2;

  ${(args) => typoAsCSS(args.lookAndFeel.labelTypo)};
  color: ${(args) => args.lookAndFeel.labelColor};

  & > i {
    color: red;
  }
`

export const Actions = styled.div<{
  lookAndFeel: AttachmentPhotoLookAndFeel;
  size: number;
}>`
  position: absolute;
  width: ${(args) => args.lookAndFeel.actionsSize * args.size}px;
  height: ${(args) => args.lookAndFeel.actionsSize}px;
  top: ${(args) => args.lookAndFeel.actionsTop}px;
  right: ${(args) => args.lookAndFeel.actionsRight}px;

  display: flex;
`

export const ActionButton = styled.button<{
  lookAndFeel: AttachmentPhotoLookAndFeel;
}>`
  width: ${(args) => args.lookAndFeel.actionsSize}px;
  height: ${(args) => args.lookAndFeel.actionsSize}px;

  display: flex;
  justify-content: center;
  align-items: center;

  border: none;

  color: ${(args) => args.lookAndFeel.actionsColor};
  background-color: ${(args) => args.lookAndFeel.actionsBgColor};
`
